(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhd-market-5-off"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.documentElement.classList.add('bhd-market-page');
  var roots=document.querySelectorAll('.bhd-market-five');
  roots.forEach(function(root){
    if(root.dataset.ready==='true') return;
    root.dataset.ready='true';

    var isEs=root.dataset.bhdMarketLocale==='es';
    var endpoint='https://bhd-lead-capture-direct-v2.vercel.app/api/popup';
    var backendOrigin='https://bhd-lead-capture-direct-v2.vercel.app';
    var frame=root.querySelector('.bhd-market-five__iframe');
    var state=root.querySelector('[data-bhd-market-state]');
    var phone=root.querySelector('[data-bhd-market-phone]');
    var email=root.querySelector('[data-bhd-market-email]');
    var hp=root.querySelector('[data-bhd-market-hp]');
    var phoneButton=root.querySelector('[data-bhd-market-phone-submit]');
    var emailButton=root.querySelector('[data-bhd-market-email-submit]');
    var skipButton=root.querySelector('[data-bhd-market-email-skip]');
    var phoneMessage=root.querySelector('[data-bhd-market-phone-message]');
    var emailMessage=root.querySelector('[data-bhd-market-email-message]');
    var token='';
    var pending='';

    function showStep(name){
      root.querySelectorAll('[data-bhd-market-step]').forEach(function(el){
        el.classList.toggle('is-active',el.getAttribute('data-bhd-market-step')===name);
      });
      root.scrollIntoView({behavior:'smooth',block:'start'});
    }

    function message(el,text){
      if(!el) return;
      el.textContent=text||'';
      el.classList.toggle('is-visible',Boolean(text));
    }

    function normalizePhone(){
      var digits=String(phone.value||'').replace(/\D/g,'');
      if(digits.length===11&&digits.charAt(0)==='1') digits=digits.slice(1);
      return digits.length===10?'+1'+digits:'';
    }

    function validEmail(value){
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value||'').trim());
    }

    function setLoading(button,on,label){
      button.disabled=on;
      button.textContent=on?(isEs?'UN MOMENTO...':'ONE SEC...'):label;
    }

    function post(payload){
      var transport=document.createElement('form');
      transport.method='POST';
      transport.action=endpoint;
      transport.target=frame.name;
      transport.style.display='none';
      Object.keys(payload).forEach(function(key){
        var input=document.createElement('input');
        input.type='hidden';
        input.name=key;
        input.value=payload[key]==null?'':payload[key];
        transport.appendChild(input);
      });
      document.body.appendChild(transport);
      transport.submit();
      transport.remove();
    }

    phoneButton.addEventListener('click',function(){
      var normalized=normalizePhone();
      var selectedState=state.value||'';
      if(!selectedState){
        message(phoneMessage,isEs?'Elige tu estado primero.':'Choose your state first.');
        state.focus();
        return;
      }
      if(!normalized){
        message(phoneMessage,isEs?'Ingresa un número válido de 10 dígitos de EE. UU.':'Enter a valid 10 digit U.S. phone number.');
        phone.focus();
        return;
      }
      pending='phone';
      message(phoneMessage,'');
      setLoading(phoneButton,true,isEs?'MÁNDAME MIS $5':'TEXT ME MY $5');
      post({
        action:'phone',
        phone:normalized,
        state:selectedState,
        form_id:'market_5_off_landing',
        form_type:'landing_page',
        form_location:'market_qr',
        tag_profile:'market_welcome',
        flow_tag:'BHD | Flow | Welcome',
        source_tag:'BHD | Source | Market',
        intent_tag:'BHD | Intent | Market Discount',
        channel_tag:'BHD | Channel | SMS',
        state_tag:'BHD | State | '+selectedState,
        taxonomy_tags:'BHD | Lead, BHD | Channel | SMS, BHD | Source | Market, BHD | Intent | Market Discount, BHD | Flow | Welcome, BHD | State | '+selectedState,
        website:hp.value||''
      });
    });

    emailButton.addEventListener('click',function(){
      var value=String(email.value||'').trim().toLowerCase();
      if(!validEmail(value)){
        message(emailMessage,isEs?'Ingresa un correo electrónico válido.':'Enter a valid email address.');
        email.focus();
        return;
      }
      pending='email';
      message(emailMessage,'');
      setLoading(emailButton,true,isEs?'AGREGAR MI CORREO':'ADD MY EMAIL');
      post({
        action:'email',
        email:value,
        popupToken:token,
        tag_profile:'market_welcome',
        flow_tag:'BHD | Flow | Welcome',
        source_tag:'BHD | Source | Market',
        intent_tag:'BHD | Intent | Market Discount',
        channel_tag:'BHD | Channel | Email',
        taxonomy_tags:'BHD | Lead, BHD | Channel | Email, BHD | Source | Market, BHD | Intent | Market Discount, BHD | Flow | Welcome',
        website:hp.value||''
      });
    });

    skipButton.addEventListener('click',function(){
      pending='skip_email';
      skipButton.disabled=true;
      post({action:'skip_email',popupToken:token,website:hp.value||''});
    });

    window.addEventListener('message',function(event){
      if(event.origin!==backendOrigin) return;
      var data=event.data||{};
      if(data.source!=='bhd-popup-capture') return;
      var result=data.payload||{};

      if(pending==='phone'){
        setLoading(phoneButton,false,isEs?'MÁNDAME MIS $5':'TEXT ME MY $5');
        if(!result.ok){
          message(phoneMessage,result.error||(isEs?'No pudimos guardar tu número. Inténtalo de nuevo.':'We could not save your number. Please try again.'));
          pending='';
          return;
        }
        token=result.popupToken||'';
        pending='';
        showStep('email');
        setTimeout(function(){email.focus();},100);
        return;
      }

      if(pending==='email'){
        setLoading(emailButton,false,isEs?'AGREGAR MI CORREO':'ADD MY EMAIL');
        if(!result.ok){
          message(emailMessage,result.error||(isEs?'No pudimos guardar tu correo. Puedes omitirlo y conservar tu cupón por mensaje.':'We could not save your email. You can skip it and keep the text voucher.'));
          pending='';
          return;
        }
        pending='';
        showStep('success');
        return;
      }

      if(pending==='skip_email'){
        skipButton.disabled=false;
        pending='';
        showStep('success');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
